import type { StateCreator } from 'zustand';

import { resetGuidedDoctorConsult, setFieldsState, setIsDirty, toggleSection } from './actions';
import { DEFAULT_STATE } from './constants';
import type { GuidedDoctorConsultsSliceType } from './types';

export const guidedDoctorConsultsSlice: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsSliceType
> = (set, get, store) => ({
  // State
  ...DEFAULT_STATE,

  // Actions
  setFieldsState: (key, value) => setFieldsState(set, get, store)(key, value),
  setIsDirty: (isDirty) => setIsDirty(set, get, store)(isDirty),
  toggleSection: (sectionName) => toggleSection(set, get, store)(sectionName),
  resetGuidedDoctorConsult: () => resetGuidedDoctorConsult(set, get, store)(),
});
